/* src/components/landing/LpHero.jsx */
import React from 'react';
import { Link } from 'react-router-dom';
import { BANKS_HERO } from '../../data/landing';

const AVATARS = [
  { t: 'MC', c: '#3B82F6' }, { t: 'RP', c: '#8B5CF6' },
  { t: 'AL', c: '#EC4899' }, { t: '+',  c: 'var(--accent)' },
];

const BANK_TAGS = [
  ['BRB','#003882'], ['STN','#EC0000'], ['ITU','#FF6600'],
  ['ITR','#FF500F'], ['BRD','#CC092F'], ['CXA','#005CA9'],
];

export default function LpHero({ addReveal, revealStyle, scrollTo, btnPrimary, btnOutline, btnLarge }) {
  return (
    <section className="s-pad" style={{ padding: '160px 0 100px', position: 'relative', overflow: 'hidden' }}>
      {/* bg glow */}
      <div style={{ position: 'absolute', top: -200, right: -200, width: 700, height: 700, background: 'radial-gradient(circle, rgba(0,214,143,0.15) 0%, transparent 70%)', pointerEvents: 'none' }} />

      <div className="container hero-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 60, alignItems: 'center' }}>

        {/* ── Left copy ── */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          <span className="hero-badge" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 14px', borderRadius: 100, fontSize: '0.8rem', fontWeight: 600, background: 'rgba(0,214,143,0.15)', color: 'var(--accent)', border: '1px solid rgba(0,214,143,0.2)', marginBottom: 24 }}>
            🚀 Novo: Comparativo com exportação em PDF
          </span>

          <h1 className="serif hero-title" style={{ fontSize: '3.8rem', letterSpacing: '-0.02em', marginBottom: 24 }}>
            Compare financiamentos de <em>6 bancos</em> em segundos
          </h1>

          <p className="hero-sub" style={{ fontSize: '1.15rem', color: 'var(--text-muted)', maxWidth: 480, marginBottom: 36, lineHeight: 1.7 }}>
            A ferramenta definitiva para correspondentes bancários, assessorias de crédito e imobiliárias. Simule, compare e feche o melhor negócio para seu cliente.
          </p>

          <div className="hero-actions" style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 48 }}>
            <Link to={`https://wa.me/5561991826667?text=${encodeURIComponent('Começar grátis')}`} target="_blank" rel="noopener noreferrer" style={{ ...btnPrimary, ...btnLarge }}>Testar grátis por 7 dias</Link>
            <a href="#como-funciona" onClick={scrollTo('como-funciona')} style={{ ...btnOutline, ...btnLarge }}>Como funciona</a>
          </div>

          <div className="hero-social" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <div style={{ display: 'flex' }}>
              {AVATARS.map(({ t, c }, i) => (
                <span key={i} style={{ width: 36, height: 36, borderRadius: '50%', border: '2.5px solid #fff', marginLeft: i === 0 ? 0 : -10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.7rem', fontWeight: 600, color: t === '+' ? 'var(--primary)' : '#fff', background: c }}>{t}</span>
              ))}
            </div>
            <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>
              <strong style={{ color: 'var(--primary)' }}>+200 correspondentes</strong> já utilizam
            </span>
          </div>
        </div>

        {/* ── Right visual ── */}
        <div className="hero-visual" style={{ position: 'relative', zIndex: 1 }}>

          {/* Float: economy */}
          <div style={{ position: 'absolute', top: 20, right: -30, background: '#fff', borderRadius: 12, padding: '14px 18px', boxShadow: '0 12px 40px rgba(0,0,0,0.1)', zIndex: 2, animation: 'lpFloat 6s ease-in-out infinite', display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 8, background: 'rgba(0,214,143,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem' }}>💰</div>
            <div>
              <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>Economia encontrada</div>
              <div style={{ fontSize: '1rem', fontWeight: 700, color: 'var(--accent)' }}>R$ 47.320</div>
            </div>
          </div>

          {/* Float: banks */}
          <div style={{ position: 'absolute', bottom: 40, left: -20, background: '#fff', borderRadius: 12, padding: '14px 18px', boxShadow: '0 12px 40px rgba(0,0,0,0.1)', zIndex: 2, animation: 'lpFloat 6s ease-in-out infinite', animationDelay: '-3s' }}>
            <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', marginBottom: 6 }}>Bancos integrados</div>
            <div style={{ display: 'flex', gap: 6 }}>
              {BANK_TAGS.map(([s, c]) => (
                <div key={s} style={{ width: 28, height: 28, borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.55rem', fontWeight: 700, color: '#fff', background: c }}>{s}</div>
              ))}
            </div>
          </div>

          {/* Dashboard preview */}
          <div style={{ background: 'var(--primary)', borderRadius: 20, padding: 24, boxShadow: '0 40px 80px rgba(11,29,53,0.2), 0 16px 40px rgba(11,29,53,0.15)', transform: 'perspective(1200px) rotateY(-4deg) rotateX(2deg)' }}>
            {/* Window dots */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
              {['#FF5F57','#FEBC2E','#28C840'].map(c => <div key={c} style={{ width: 10, height: 10, borderRadius: '50%', background: c }} />)}
            </div>
            <div style={{ background: 'rgba(255,255,255,0.05)', borderRadius: 12, padding: 20 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.1em' }}>Comparativo MultiBanco</span>
                <span style={{ color: 'var(--accent)', fontSize: '0.75rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--accent)', animation: 'lpPulse 2s infinite' }} />
                  Simulação ativa
                </span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {BANKS_HERO.map((b) => (
                  <div key={b.name} style={{ display: 'grid', gridTemplateColumns: '80px 1fr 90px', alignItems: 'center', gap: 12, padding: '10px 14px', borderRadius: 8, background: b.best ? 'rgba(0,214,143,0.08)' : 'rgba(255,255,255,0.04)', border: b.best ? '1px solid rgba(0,214,143,0.15)' : 'none' }}>
                    <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.8rem', fontWeight: 500 }}>
                      {b.name}
                      {b.best && <span style={{ display: 'inline-block', background: 'var(--accent)', color: 'var(--primary)', fontSize: '0.6rem', fontWeight: 700, padding: '2px 6px', borderRadius: 4, marginLeft: 6, textTransform: 'uppercase' }}>Melhor</span>}
                    </span>
                    <div style={{ height: 6, borderRadius: 3, background: 'rgba(255,255,255,0.08)', overflow: 'hidden' }}>
                      <div style={{ height: '100%', borderRadius: 3, width: `${b.pct}%`, background: b.cor }} />
                    </div>
                    <span style={{ color: b.best ? 'var(--accent)' : 'rgba(255,255,255,0.6)', fontSize: '0.78rem', textAlign: 'right', fontWeight: b.best ? 700 : 500, fontVariantNumeric: 'tabular-nums' }}>{b.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
